import React from 'react';
import { Navigate } from 'react-router-dom';
import { adminApi } from '../../services/api';

export const AdminRoute: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  if (!adminApi.hasToken()) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
};
